export default __webpack_public_path__ + "static/media/amongus.5ff45620.jpg";